import { CreateBudgetFromTemplate } from "@project/domain/models/budget-template/create-budget-from-template";
import { injectable } from "inversify";

@injectable()
export class CreateBudgetFromTemplateMapper {
    map(createBudgetFromTemplate: CreateBudgetFromTemplate): any {
        return {
            template_id: createBudgetFromTemplate.template_id,
            name: createBudgetFromTemplate.name,
            description: createBudgetFromTemplate.description,
            finantial_entity: createBudgetFromTemplate.finantial_entity,
        };
    }
}
